import 'babel-polyfill'
import React from 'react'
import { render } from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import { Router, Route, IndexRoute, Link, browserHistory } from 'react-router'
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux'

import NotificationSystem from 'react-notification-system'
import notificationBypass from './lib/NotificationBypass'

import { promptsMiddleware, Prompts } from './components/Prompts'

import reducer from './reducers'
import { saveChanges } from './lib/MetagnosticDuck/persistence'

// #duck switch this import. nothing else here.
import { fetchAll } from './MetagnosticDuck'

import Login from './components/Login'
import RequestPasswordReset from './components/RequestPasswordReset'
import ResetPassword from './components/ResetPassword'

import Home from './components/Home'
import About from './components/About'
import Navigation from './containers/Navigation'
import TripsPage from './trips/TripsPage'
import TestPage from './test/TestPage'
import TripPage from './trips/TripPage'
import Block from './blocks/Block'
import Activity from './activities/Activity'
import DocumentsReport from './documents/DocumentsReport'
import SupplierPage from './suppliers/Supplier'

import BlocksPage from './blocks/BlocksPage'
import ActivitiesPage from './activities/ActivitiesPage'
import SuppliersPage from './suppliers/SuppliersPage'
import ProductPage from './products/ProductPage'
import ProductsPage from './products/ProductsPage'
import CitiesPage from './cities/CitiesPage'
import ExpensesPage from './expenses/ExpensesPage'
import PurchasesPage from './reservations/Purchases'
import ReservationsReport from './reservations/Report'
import PaymentsPage from './trips/AllPayments'
import SavingSpinner from './containers/SavingSpinner'

import { startSocket } from './socketClient.js'
// import fetchDoc from './fetchDoc.js'
import fetchPermissions from './actions/permissionsActions'

import { setLanguage } from './lib/text.js'
import { fetchLoginData } from './actions/loginData'

import { randstr, minutes, seconds } from '../lib/Tools'
import { setAPISessionKey } from './lib/APIClient'
import appDocsPage from './appDocs/appDocsPage'
import DashboardPage from './dashboard/DashboardPage'

import * as exchangeWatcher from './lib/exchangeRateClient'
import UsersAdminPage from './users/UsersAdminPage'
import LogPage from './logs/LogPage'

// can't import this from Price.jsx bc reasons
import "./components/Price.less"
import "react-widgets/lib/less/react-widgets.less"

exchangeWatcher.init()

const SESSION_KEY = randstr(16)
setAPISessionKey(SESSION_KEY)

/**
 * create and set the store up
 */

const store = createStore(
  reducer,
  compose(
    applyMiddleware(
      thunk,
      routerMiddleware(browserHistory),
      promptsMiddleware,
      // require('redux-logger')(),
      // require('./perf.js')
      // require('redux-perf-middleware')
    ),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )
)

const history = syncHistoryWithStore(browserHistory, store)

/**
 * fetch all the shit
 */
function fetchAllTheShit() {
  console.log("Gonna fetch all the shit")
  store.dispatch(fetchLoginData())
  store.dispatch(fetchPermissions())
  fetchAll(store.dispatch)
}

fetchAllTheShit()

/**
 * start the autosave
 */

setInterval(() => store.dispatch(saveChanges()), seconds(1))
setInterval(fetchAllTheShit, minutes(60))

/**
 * language
 */

setLanguage(store.getState().ui.language)

/**
 * socket.io
 */
startSocket(SESSION_KEY, store, fetchAllTheShit)

/**
 *
 */
class App extends React.PureComponent
{
  render() {
    return (
      <div>
        <Navigation history={history} />
        <SavingSpinner />
        <Router history={history}>
          <Route path="/">
            <IndexRoute component={Login} />
            <Route path="login"                          component={Login} />
            <Route path="requestpasswordreset/"          component={RequestPasswordReset} />
            <Route path="requestpasswordreset/:username" component={RequestPasswordReset} />
            <Route path="resetpassword/:username/:token" component={ResetPassword} />

            <Route path="about" component={About} />
            <Route path="private/">
              <IndexRoute component={Login} />
              <Route path="login"        component={Login}          />
              <Route path="home"         component={Home}           />
              <Route path="admin"        component={BlocksPage}     />
              <Route path="blocks"       component={BlocksPage}     />
              <Route path="activities"   component={ActivitiesPage} />
              <Route path="suppliers"    component={SuppliersPage}  />
              <Route path="product/:id"  component={ProductPage}    />
              <Route path="products"     component={ProductsPage}   />
              <Route path="cities"       component={CitiesPage}     />
              <Route path="expenses"     component={ExpensesPage}   />
              <Route path="oper"         component={TripsPage}      />
              <Route path="trip/:id"     component={TripPage}       />
              <Route path="block/:id"    component={Block}          />
              <Route path="activity/:id" component={Activity}       />
              <Route path="supplier/:id" component={SupplierPage}   />
              <Route path="test"         component={TestPage}       />
              <Route path="purchases"    component={PurchasesPage}  />
              <Route path="payments"     component={PaymentsPage}   />
              <Route path="appDocs"      component={appDocsPage}    />
              <Route path="dashboard"    component={DashboardPage}  />
              <Route path="users"        component={UsersAdminPage} />
              <Route path="documents"    component={DocumentsReport} />

              <Route
                path="city/:id"
                component={
                  (props) => (
                    <div style={{ margin: 20, fontSize: "1.4em" }}>
                      {"Redirigiendo... "}
                      <Link to={`/private/cities?editingId=${encodeURIComponent(props.params.id)}&modal=edit`}>
                        click aquí si la redirección no funciona
                      </Link>
                    </div>
                  )
                }
              />

              <Route path="log/:col/:id" component={LogPage} />

              <Route path="reservationsreport" component={ReservationsReport} />
            </Route>
          </Route>
        </Router>

        <NotificationSystem
          ref={component => notificationBypass.setNotificationSystem(component)}
        />
        <Prompts />
      </div>
    )
  }
}

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)
